// #region imports

// --- HS Code
import { RespondentModel } from './respondent-model';

// #endregion

export interface RespondentValidationResultModel {
  respondent: RespondentModel;
  isValid: boolean;
  errorMessage: string;
}
